import { css } from '@emotion/core';
import colors from '../../_shared/colors';

const styles = {
  wrapper: css`
    padding: 16px 24px;
  `,
  titleBlock: css`
    text-align: center;
    margin: 4px auto 12px;
    width: 100%;
  `,
  headerRow: css`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 8px;
  `,
  title: css`
    font-size: 22px;
    font-weight: 600;
    color: #222;
    margin: 0;
    text-align: center;
  `,
  subtitle: css`
    font-size: 13px;
    color: #777;
    margin: 4px auto 0;
    text-align: center;
    max-width: 720px;
  `,
  topActions: css`
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
  `,
  superAdminHint: css`
    font-size: 11px;
    color: #999;
    text-align: right;
    width: 100%;
    margin-top: 4px;
  `,
  filterBar: css`
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 16px;
    margin: 16px 0;
  `,
  filterGrid: css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 12px;
  `,
  dateRangeCol: css`
    grid-column: span 2;
    min-width: 280px;
  `,
  filterLabel: css`
    font-size: 12px;
    color: #555;
    margin-bottom: 4px;
    display: block;
  `,
  filterHint: css`
    font-size: 11px;
    color: #999;
    margin-top: 4px;
  `,
  filterActions: css`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
  `,
  criticalRow: css`
    background-color: #fff1f0 !important;
  `,
  priorityPill: css`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    min-width: 60px;
  `,
  tagPill: css`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    background: #fff7e6;
    color: #d48806;
    border: 1px solid #ffe7ba;
    font-size: 12px;
    text-align: center;
  `,
  avatar: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #e6f7ff;
    color: #1890ff;
    font-size: 12px;
    font-weight: 600;
  `,
  completedY: css`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 4px;
    border: 1px solid #95de64;
    background: #f6ffed;
    color: #389e0d;
    font-weight: 500;
    min-width: 28px;
    text-align: center;
  `,
  completedN: css`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 4px;
    border: 1px solid #ffa39e;
    background: #fff1f0;
    color: #cf1322;
    font-weight: 500;
    min-width: 28px;
    text-align: center;
  `,
  iconBtn: css`
    cursor: pointer;
    color: #555;
    margin-right: 8px;
    &:hover { color: ${colors && colors.highlight ? colors.highlight : '#1890ff'}; }
  `,
  iconBtnDanger: css`
    cursor: pointer;
    color: #cf1322;
    &:hover { color: #a8071a; }
  `,
};

export const priorityColor = (p) => {
  switch (p) {
    case 'High': return { background: '#fff1f0', color: '#cf1322', border: '1px solid #ffa39e' };
    case 'Medium': return { background: '#fffbe6', color: '#ad8b00', border: '1px solid #ffe58f' };
    case 'Low': return { background: '#f6ffed', color: '#52c41a', border: '1px solid #b7eb8f' };
    default: return { background: '#fafafa', color: '#bfbfbf', border: '1px solid #e8e8e8' };
  }
};

export default styles;
